import { useState } from 'react';
import { LOCALE_DEFAULT, LOCALES, KEYS } from '../../../../l18n/constants';
import allTranslations from '../../../../l18n/translations';

function getValidLocale(ToBeValidatedlocale, localeIfInvalid = LOCALE_DEFAULT) {
  const trimmedAndLowerCasedLocale = `${ToBeValidatedlocale}`.trim().toLowerCase();
  return Object.values(LOCALES).includes(trimmedAndLowerCasedLocale) ? trimmedAndLowerCasedLocale : localeIfInvalid;
}

export default function useL18n(initialLocale) {
  const [currentLocale, setCurrentLocale] = useState(getValidLocale(initialLocale));

  function updateCurrentLocale(newLocale) {
    const validatedNewLocale = getValidLocale(newLocale);
    if (validatedNewLocale !== currentLocale ) {
      setCurrentLocale(validatedNewLocale);
    }
  }

  function getTranslationFor(
    translationKey,
    textOnMissingTranslation = 'TRANSLATION NOT FOUND',
    textOnMissingTranslationKey = 'TRANSLATION KEY NOT FOUND') {
    if(Object.values(KEYS).includes(translationKey)) {
      const defaultTranslation = allTranslations?.[LOCALE_DEFAULT]?.[translationKey]||null;
      const currentTranslation = allTranslations?.[currentLocale]?.[translationKey]||null;
      if(!currentTranslation) {
        if(!!defaultTranslation) {
          console.log('\nNo translation [',currentLocale,'] found for: "',translationKey,'"');
          console.log('Defaulting to default [',LOCALE_DEFAULT,'] translation: "',defaultTranslation,'"\n');
          return defaultTranslation;
        }
        else {
          console.log('\nNo translation [',currentLocale,'] found for: "',translationKey,'"');
          console.log('No translation [',LOCALE_DEFAULT,'] found for: "',translationKey,'"\n');
          return textOnMissingTranslation;
        }
      }
      else {
        return currentTranslation;
      }
    }
    else {
      console.warn('\nTranslation key "',translationKey,'" not found.\n');
      return textOnMissingTranslationKey;
    }
  }

  return { currentLocale, updateCurrentLocale, getTranslationFor }

}
